import { routeConstants } from "constants/routeConstants";
import { AiOutlineLike } from "react-icons/ai";
import {
    BiCategory,
    BiDetail,
    BiDollarCircle,
    BiLocationPlus,
    BiTargetLock,
    BiUser,
} from "react-icons/bi";
import { BsBriefcase } from "react-icons/bs";
import { CgCardSpades } from "react-icons/cg";
import { FaBusinessTime } from "react-icons/fa";
import { FiPhoneCall } from "react-icons/fi";
import { HiOutlineCurrencyDollar } from "react-icons/hi";
import { IoLanguage, IoShareSocialOutline } from "react-icons/io5";
import { LiaBusinessTimeSolid } from "react-icons/lia";
import { MdSubscriptions } from "react-icons/md";
import { TbPhoto, TbRuler2 } from "react-icons/tb";

export const sidebarItems = {
    profile: [
        {
            title: "Personal Details",
            id: routeConstants.profile.editProfile.personalDetails,
            icon: <BiUser />,
            route:
                routeConstants.profile.editProfile.root +
                routeConstants.profile.editProfile.personalDetails,
        },
        {
            title: "Photos & Videos",
            id: routeConstants.profile.editProfile.photosAndVideos,
            icon: <TbPhoto />,
            route:
                routeConstants.profile.editProfile.root +
                routeConstants.profile.editProfile.photosAndVideos,
        },
        {
            title: "Physical Details",
            id: routeConstants.profile.editProfile.physicalDetails,
            icon: <TbRuler2 />,
            route:
                routeConstants.profile.editProfile.root +
                routeConstants.profile.editProfile.physicalDetails,
        },
        {
            title: "Experience Details",
            id: routeConstants.profile.editProfile.experienceDetails,
            icon: <BsBriefcase />,
            route:
                routeConstants.profile.editProfile.root +
                routeConstants.profile.editProfile.experienceDetails,
        },
        {
            title: "Other Interests",
            id: routeConstants.profile.editProfile.otherInterests,
            icon: <CgCardSpades />,
            route:
                routeConstants.profile.editProfile.root +
                routeConstants.profile.editProfile.otherInterests,
        },
        {
            title: "Location & Languages",
            id: routeConstants.profile.editProfile.locationAndLanguages,
            icon: <IoLanguage />,
            route:
                routeConstants.profile.editProfile.root +
                routeConstants.profile.editProfile.locationAndLanguages,
        },
        {
            title: "Contact Details",
            id: routeConstants.profile.editProfile.contactDetails,
            icon: <FiPhoneCall />,
            route:
                routeConstants.profile.editProfile.root +
                routeConstants.profile.editProfile.contactDetails,
        },
    ],
    agencyProfile: [
        {
            id:
                routeConstants.profile.editProfile.agency.root +
                routeConstants.profile.editProfile.agency.companyDetails,
            title: "Company Details",
            icon: <BiUser />,
            route:
                routeConstants.profile.editProfile.agency.root +
                routeConstants.profile.editProfile.agency.companyDetails,
        },
        {
            id:
                routeConstants.profile.editProfile.agency.root +
                routeConstants.profile.editProfile.agency.contactInformation,
            title: "Contact Information",
            icon: <FiPhoneCall />,
            route:
                routeConstants.profile.editProfile.agency.root +
                routeConstants.profile.editProfile.agency.contactInformation,
        },
        {
            id:
                routeConstants.profile.editProfile.agency.root +
                routeConstants.profile.editProfile.agency.socialMedia,
            title: "Social Media",
            icon: <IoShareSocialOutline />,
            route:
                routeConstants.profile.editProfile.agency.root +
                routeConstants.profile.editProfile.agency.socialMedia,
        },
    ],
    settings: [
        {
            title: "Account",
            id: routeConstants.settings.accounts,
            icon: <BiUser />,
            route:
                routeConstants.settings.root + routeConstants.settings.accounts,
        },
        // {
        //     title: "Notifications",
        //     id: routeConstants.settings.notifications,
        //     icon: <BsBell />,
        //     route:
        //         routeConstants.settings.root +
        //         routeConstants.settings.notifications,
        // },
        {
            title: "Subscriptions",
            id: routeConstants.settings.subscriptions,
            icon: <MdSubscriptions />,
            route:
                routeConstants.settings.root +
                routeConstants.settings.subscriptions,
        },
        {
            title: "MyPlans",
            id: routeConstants.settings.plans,
            icon: <HiOutlineCurrencyDollar />,
            route: routeConstants.settings.root + routeConstants.settings.plans,
        },
    ],
    findWork: [
        {
            title: "All Castings",
            id: routeConstants.findWork.allJobs,
            icon: <FaBusinessTime />,
            route:
                routeConstants.findWork.root + routeConstants.findWork.allJobs,
        },
        {
            title: "Applied Castings",
            id: routeConstants.findWork.appliedJobs,
            icon: <LiaBusinessTimeSolid />,
            route:
                routeConstants.findWork.root +
                routeConstants.findWork.appliedJobs,
        },
        {
            title: "Liked Castings",
            id: routeConstants.findWork.likedJobs,
            icon: <AiOutlineLike />,
            route:
                routeConstants.findWork.root +
                routeConstants.findWork.likedJobs,
        },
        {
            title: "Invitation",
            id: routeConstants.findWork.invitation,
            icon: <BsBriefcase />,
            route:
                routeConstants.findWork.root +
                routeConstants.findWork.invitation,
        },
    ],
    postJob: [
        {
            title: "Category",
            id: routeConstants.postJob.category,
            icon: <BiCategory />,
            route:
                routeConstants.postJob.root + routeConstants.postJob.category,
        },
        {
            title: "Purpose",
            id: routeConstants.postJob.jobPurpose,
            icon: <BiTargetLock />,
            route:
                routeConstants.postJob.root + routeConstants.postJob.jobPurpose,
        },
        {
            title: "Location",
            id: routeConstants.postJob.jobLocation,
            icon: <BiLocationPlus />,
            route:
                routeConstants.postJob.root +
                routeConstants.postJob.jobLocation,
        },
        {
            title: "Details",
            id: routeConstants.postJob.jobDetails,
            icon: <BiDetail />,
            route:
                routeConstants.postJob.root + routeConstants.postJob.jobDetails,
        },
        {
            title: "Advance Details",
            id: routeConstants.postJob.jobAdvanceDetails,
            icon: <BiDetail />,
            route:
                routeConstants.postJob.root +
                routeConstants.postJob.jobAdvanceDetails,
        },
        {
            title: "Budget",
            id: routeConstants.postJob.jobBudget,
            icon: <BiDollarCircle />,
            route:
                routeConstants.postJob.root + routeConstants.postJob.jobBudget,
        },
    ],
    editJob: [
        {
            title: "Category",
            id: routeConstants.editJob.category,
            icon: <BiCategory />,
            route:
                routeConstants.editJob.root +
                ":id/" +
                routeConstants.editJob.category,
        },
        {
            title: "Purpose",
            id: routeConstants.postJob.jobPurpose,
            icon: <BiTargetLock />,
            route:
                routeConstants.editJob.root +
                ":id/" +
                routeConstants.editJob.jobPurpose,
        },
        {
            title: "Location",
            id: routeConstants.editJob.jobLocation,
            icon: <BiLocationPlus />,
            route:
                routeConstants.editJob.root +
                ":id/" +
                routeConstants.editJob.jobLocation,
        },
        {
            title: "Details",
            id: routeConstants.editJob.jobDetails,
            icon: <BiDetail />,
            route:
                routeConstants.editJob.root +
                ":id/" +
                routeConstants.editJob.jobDetails,
        },
        {
            title: "Advance Details",
            id: routeConstants.editJob.jobAdvanceDetails,
            icon: <BiDetail />,
            route:
                routeConstants.editJob.root +
                ":id/" +
                routeConstants.editJob.jobAdvanceDetails,
        },
        {
            title: "Budget",
            id: routeConstants.editJob.jobBudget,
            icon: <BiDollarCircle />,
            route:
                routeConstants.editJob.root +
                ":id/" +
                routeConstants.editJob.jobBudget,
        },
    ],
    listing: [
        {
            title: "Active Jobs",
            id: routeConstants.jobs.listings.active,
            icon: <FaBusinessTime />,
            route:
                routeConstants.jobs.listings.root +
                "/" +
                routeConstants.jobs.listings.active,
        },
        {
            title: "Inactive Jobs",
            id: routeConstants.jobs.listings.inActive,
            icon: <FaBusinessTime />,
            route:
                routeConstants.jobs.listings.root +
                "/" +
                routeConstants.jobs.listings.inActive,
        },
        {
            title: "Expired Jobs",
            id: routeConstants.jobs.listings.expired,
            icon: <FaBusinessTime />,
            route:
                routeConstants.jobs.listings.root +
                "/" +
                routeConstants.jobs.listings.expired,
        },
        {
            title: "Drafts",
            id: routeConstants.jobs.listings.drafts,
            icon: <FaBusinessTime />,
            route:
                routeConstants.jobs.listings.root +
                "/" +
                routeConstants.jobs.listings.drafts,
        },
    ],
};
